import './Footer.css';

const Footer = () => {
  return (
    <>
      <footer>
        <div className='footer-content'>
          <h3>Info Penerjemah</h3>
          <p>Menjaga Kepercayaan Pelanggan Dengan Kualitas Layanan Terbaik</p>
        </div>
        <div className='footer-bottom'>
          <p>copyright &copy;2022 | Info Penerjemah</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
